import React from 'react';
import { PageContext } from '.';
import { PageType } from '../models/PageData';
import Setup from '../Setup';
import Status from '../Status';
import InventoryMap from '../InventoryMap';
import AdminVend from '../AdminVend';
import Engine from './Engine';

function PageHandler() {
  const { activePageId } = React.useContext(PageContext);
  switch (activePageId) {
    case PageType.SCREEN_ADMIN:
      return <Setup />;
    case PageType.SCREEN_STATUS:
      return <Status />;
    case PageType.SCREEN_INVENTORY:
      return <InventoryMap />;
    case PageType.SCREEN_ADMIN_VEND:
      return <AdminVend />;
    default:
      return <Engine />;
  }
}

export default PageHandler;
